import BookingPlaces from '@src/components/template/admin/BookingPlaces';

export default function BookingPlaceList() {
  return <BookingPlaces />;
}
